<template>
  <div id="app">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "./assets/css/font.css";
@import "./assets/css/style.css";
@import "./assets/css/common.css";

@import "https://unicons.iconscout.com/release/v3.0.3/css/line.css";
@import "https://unicons.iconscout.com/release/v3.0.3/css/solid.css";
@import "https://cdn.jsdelivr.net/npm/xeicon@2.3.3/xeicon.min.css";
</style>